import { Link } from "react-router-dom";

export const LegalSection = ({ title, children }) => (
  <section className="space-y-3">
    <h2 className="font-serif text-xl font-bold text-[#FDF8EE]">{title}</h2>
    <div className="space-y-3 text-[15px] leading-relaxed text-[#E6D9BF] [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-1.5 [&_a]:text-[#E8A030] [&_a]:underline [&_strong]:text-[#FDF8EE]">
      {children}
    </div>
  </section>
);

export const LegalLayout = ({ title, updated, testId, children }) => (
  <div className="min-h-screen bg-[#0A0600] text-[#FDF8EE]" data-testid={testId}>
    <header className="h-[56px] border-b border-[rgba(232,160,48,0.1)] bg-[#1C1004] flex items-center justify-between px-6">
      <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity" data-testid="legal-home-link">
        <div className="w-[9px] h-[9px] bg-[#E8A030] rotate-45" />
        <span className="font-serif font-black text-lg">Ryan</span>
      </Link>
      <nav className="flex gap-6 font-mono text-[10px] uppercase tracking-[1.5px]">
        <Link to="/privacy" className="text-[#D9C8A6] hover:text-[#E8A030] transition-colors" data-testid="legal-nav-privacy">Privacy</Link>
        <Link to="/terms" className="text-[#D9C8A6] hover:text-[#E8A030] transition-colors" data-testid="legal-nav-terms">Terms</Link>
      </nav>
    </header>
    <main className="max-w-3xl mx-auto px-6 py-14 space-y-10">
      <div>
        <h1 className="font-serif text-4xl sm:text-5xl font-black tracking-[-1px]">{title}</h1>
        <p className="font-mono text-[11px] text-[#D9C8A6] uppercase tracking-[1px] mt-3">Last updated {updated} · MERA Technology</p>
      </div>
      {children}
      <p className="text-[13px] text-[#D9C8A6] border-t border-[rgba(232,160,48,0.15)] pt-6">
        Questions? Email <a href="mailto:ryan@ryanremembers.com" className="text-[#E8A030] underline" data-testid="legal-contact-email">ryan@ryanremembers.com</a>.
      </p>
    </main>
  </div>
);
